module.exports = __webpack_public_path__ + "dingbeauty-build/img/store_big@1.a41ea93d.jpg";